import AttachAccount from './container/index';

export default AttachAccount;



// WEBPACK FOOTER //
// ./src/views/AttachAccount/index.js